import React from 'react';

export const ListItem = (props) => <li {...props}>{ props.children }</li>